import {css} from 'lit'; export default css`:host .nav-rail{height:100%}:host chameleon-popover{--z-index:99999}:host .chameleon-custom-navigation-rail-item{width:inherit}chameleon-svg{--goto-icon-size:24px}`;
    